import { render } from "./suppliers.vue?vue&type=template&id=39252b5c&scoped=true"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"

import "./suppliers.vue?vue&type=style&index=0&id=39252b5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39252b5c"]])

export default __exports__